import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const readStores = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.stores}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.stores}?per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateStoreTicketPersonalization = async (storeId, data) =>
  api
    .put(`${url.stage.stores}/${storeId}/ticket-personalization`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const readCompanies = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.companies}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.companies}?per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateCompanyTicketPersonalization = async (companyId, data) =>
  api
    .put(`${url.stage.companies}/${companyId}/ticket-personalization`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  readStores,
  updateStoreTicketPersonalization,
  readCompanies,
  updateCompanyTicketPersonalization,
}
